'use client'

import { useCallback, useEffect } from 'react'

import Cookies from 'js-cookie'
import { useExitIntent } from 'use-exit-intent'

import { useDemoRequestModal } from '@/app/components/DemoRequest/DemoRequestModalContext'

const DEMO_FORM_PAGE_SELECTOR = '[data-demo-form-page]'

export const DemoRequestModalExitIntent = () => {
  const { openModal, isOpen } = useDemoRequestModal()
  const isRegisteredUser = Boolean(Cookies.get('bearer')) || Boolean(Cookies.get('rasuwa'))

  const { registerHandler, isUnsubscribed, unsubscribe } = useExitIntent({
    cookie: { daysToExpire: 1, key: 'demo-exit-intent' },
    desktop: {
      triggerOnIdle: true,
      useBeforeUnload: false,
      triggerOnMouseLeave: true,
      delayInSecondsToTrigger: 5,
    },
    mobile: { triggerOnIdle: true, delayInSecondsToTrigger: 5 },
  })

  const handleOpen = useCallback(() => {
    if (document.querySelector(DEMO_FORM_PAGE_SELECTOR)) return
    openModal()
  }, [openModal])

  useEffect(() => {
    if (!isRegisteredUser && !isUnsubscribed) {
      registerHandler({ id: 'openDemoModal', handler: handleOpen })
    }
  }, [isUnsubscribed, registerHandler, handleOpen, isRegisteredUser])

  useEffect(() => {
    if (isOpen && !isUnsubscribed) unsubscribe()
  }, [isOpen, isUnsubscribed, unsubscribe])

  return null
}
